<div class="toast">
  <div class="toast__container">
    <div class="toast__icon">
      <ng-content select="[appToastIcon]"></ng-content>
    </div>
    <div class="toast__content">
      <p *ngIf="title" class="title">{{title}}</p>
      <p class="message"><ng-content></ng-content></p>
    </div>
  </div>
  <div class="toast__cta">
    <ng-content select="[appToastCta]"></ng-content>
  </div>
</div>
